import LogoText from "src/Components/LogoText/LogoText";
import { IClinicInfo } from "src/Utils/Hooks/GetClinicInfo/useGetClinicInfo";
import { MailIcon, PhoneIcon, WhatsAppIcon, WeChatIcon, FacebookIcon, InstagramIcon, OtherChannelIcon } from "src/SharedComponents/Icons/Icons";
import { useMemo } from "react";

const channelIconMap: Record<string, React.ReactNode> = {
    whatsapp: <WhatsAppIcon />,
    wechat: <WeChatIcon />,
    facebook: <FacebookIcon />,
    instagram: <InstagramIcon />,
    other: <OtherChannelIcon />,
};

interface IClinicSupportInfoParams {
    clinicDetails: IClinicInfo;
}
const ClinicSupportInfo: React.FC<IClinicSupportInfoParams> = ({ clinicDetails }) => {
    const show = useMemo(() => clinicDetails?.supportContactDetail?.contactNumber ||
        clinicDetails?.supportContactDetail?.email ||
        clinicDetails?.supportContactDetail?.supportChannelType ||
        clinicDetails?.supportContactDetail?.supportChannel, [clinicDetails?.supportContactDetail]);
    const channelIcon = channelIconMap[clinicDetails.supportContactDetail?.supportChannelType?.toLocaleLowerCase() ?? ''] ?? <OtherChannelIcon />;
    return (
        <>
            {show &&
                <>
                    <div className="row">
                        <div className="mb-2 col-9">
                            <b>Support Contact</b>
                        </div>
                    </div>
                    {clinicDetails.supportContactDetail?.email && <LogoText logoElement={<MailIcon />} text={clinicDetails.supportContactDetail?.email} /> }
                    {clinicDetails.supportContactDetail?.contactNumber && <LogoText logoElement={<PhoneIcon />} text={clinicDetails.supportContactDetail?.contactNumber} /> }
                    {clinicDetails.supportContactDetail?.supportChannel && <LogoText logoElement={channelIcon} text={clinicDetails.supportContactDetail?.supportChannel} />}
                </>}
        </>)
}

export default ClinicSupportInfo;
